import { getAuthToken } from "./authService";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const marketingService = {
  // Get marketing dashboard data
  async getMarketingDashboardData() {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_BASE_URL}/api/marketing/dashboard`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch marketing dashboard data");
      }

      const data = await response.json();
      console.log("📊 [MARKETING] Dashboard data received:", data);
      return data;
    } catch (error) {
      console.error("Error fetching marketing dashboard data:", error);
      // Return mock data as fallback
      return getMockMarketingData();
    }
  },

  // Export guardians emails
  async exportGuardiansEmails() {
    try {
      const token = getAuthToken();
      const response = await fetch(
        `${API_BASE_URL}/api/marketing/guardians/export/emails`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to export guardians emails");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "guardians-emails.csv";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return { success: true };
    } catch (error) {
      console.error("Error exporting guardians emails:", error);
      throw error;
    }
  },

  // Export client contacts emails
  async exportClientContactsEmails() {
    try {
      const token = getAuthToken();
      const response = await fetch(
        `${API_BASE_URL}/api/marketing/clients/contacts/export/emails`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to export client contacts emails");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "client-contacts-emails.csv";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return { success: true };
    } catch (error) {
      console.error("Error exporting client contacts emails:", error);
      throw error;
    }
  },
};

// Mock data for fallback
function getMockMarketingData() {
  return {
    success: true,
    statistics: {
      guardians: 1250,
      placedGuardians: 890,
      clientContacts: 450,
    },
    source: "mock",
  };
}
